import {MouseEventHandler} from 'react';

export interface PublishingDripboardsPanelProps {
  // add props here
  onClose: () => void | MouseEventHandler;
}

export interface PublishingDripBoardsScreensResponse {
  isNewUser: boolean;
  screens: DripBoardsScreens[];
}

export interface DripBoardsScreens {
  id: number;
  name: string;
}

export enum DripBoardsPanelProgressState {
  STEP_CONNECT = 'STEP_CONNECT',
  STEP_AUTH = 'STEP_AUTH',
  STEP_LOADING = 'STEP_LOADING',
  STEP_PUBLISH = 'STEP_PUBLISH',
  STEP_UNPUBLISH = 'STEP_UNPUBLISH',
}
